import { createFileRoute, redirect } from '@tanstack/react-router';
import { parseGuidanceSearch } from '@/features/agency';

/** The short address to send the team: app.hayven.ai/guidance. */
export const Route = createFileRoute('/_auth/guidance')({
  validateSearch: parseGuidanceSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/agency/guidance', search, replace: true });
  },
});
